import { IVisitsByProperty } from "../types/ownerDashboard.types";

const GENERIC_PROPERTY_TYPES = new Set([
  "apartamento",
  "casa",
  "kitnet",
  "sala",
  "loja",
  "cobertura",
  "studio",
]);

export function getPropertyFilterLabel(property: IVisitsByProperty): string {
  const titleParts = property.property_title
    .split(",")
    .map((part) => part.trim())
    .filter(Boolean);

  const address = property.property_address.trim();
  const primaryTitle = titleParts[0]?.toLowerCase() ?? "";
  const locationHint = titleParts.length > 1 ? titleParts.slice(1).join(", ") : titleParts[0];

  if (locationHint && address && titleParts.length > 1) {
    return `${locationHint} · ${address}`;
  }

  if (
    locationHint &&
    address &&
    titleParts.length === 1 &&
    !GENERIC_PROPERTY_TYPES.has(primaryTitle)
  ) {
    return `${locationHint} · ${address}`;
  }

  return address || locationHint || `Imóvel #${property.property_id}`;
}
